import React, { useState } from 'react';
import { Button } from '~/components/Button';
import style from './index.module.scss';

interface ISecretTextProps {
  value?: string | null;
}

export const SecretText: React.FC<ISecretTextProps> = ({ value }) => {
  const [visible, setVisible] = useState(false);

  if (!value) {
    return null;
  }

  return (
    <span className={style.secretText}>
      <span className={style.text}>{visible ? value : '••••••••'}</span>
      <Button
        small
        iconOnly
        type="button"
        className={style.toggleButton}
        title={visible ? 'Hide' : 'Show'}
        aria-label={visible ? 'Hide value' : 'Show value'}
        onClick={() => setVisible(v => !v)}
        leftIcon={<i className={`fa fa-${visible ? 'eye-slash' : 'eye'}`} />}
      />
    </span>
  );
};
